import React from 'react'
import * as Errors from '@morningtrain/react-errors'
import Card from 'ui/cards/Card'
import Logo from 'widgets/branding/Logo'
import { PageTitle } from '@morningtrain/react-app'
import {Translation} from "@morningtrain/react-translations";

export default function Auth (props) {
  return (
    <div className='min-h-screen flex flex-col justify-between bg-background'>
      <div className='min-h-full flex flex-col justify-center pt-24 pb-3 sm:px-6 lg:px-8'>
        <div className='sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center'>
          <div className='w-24'>
            <Logo />
          </div>
          <h2 className='mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900'>
            <PageTitle />
          </h2>
        </div>

        <div className='mt-8 mx-2 sm:mx-auto sm:w-full sm:max-w-md'>
          <Card>
            <Errors.Boundary>
              {props.children}
            </Errors.Boundary>
          </Card>
        </div>
      </div>

      <footer className="bg-background attribution h-6">
        <a href="https://github.com/nrkno/yr-weather-symbols"><Translation name={('generic.attributions.weather_icons')}/></a>{' '}
        <Translation name={'generic.attributions.used_in_app'} />{' '}
        <a href="https://creativecommons.org/licenses/by/4.0/deed.en"><Translation name={'generic.attributions.cc40'}/></a>,{' '}
        <Translation name={'generic.attributions.no_changes_applied'}/>.
      </footer>
    </div>
  )
}
